import Player from "@vimeo/player";
import ScrollObserver from "./helpers/ScrollObserver";

export default class VimeoPlayer {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.vimeo-player'), el => {
			new VimeoPlayer(el)
		});
	}

	static classes = {
		node: 'vimeo-player',
		get overlay() {
			return this.node + '__overlay'
		},
		get poster() {
			return this.node + '__poster'
		},
		get iframe() {
			return this.node + '__iframe'
		},
		get inner() {
			return this.node + '__inner'
		},
		state: {
			get initialised() {
				return VimeoPlayer.classes.node + '--is-initialized'
			},
			get unstarted() {
				return VimeoPlayer.classes.node + '--is-unstarted'
			},
			get ended() {
				return VimeoPlayer.classes.node + '--is-ended'
			},
			get playing() {
				return VimeoPlayer.classes.node + '--is-playing'
			},
			get paused() {
				return VimeoPlayer.classes.node + '--is-paused'
			},
			get buffering() {
				return VimeoPlayer.classes.node + '--is-buffering'
			},
			get cued() {
				return VimeoPlayer.classes.node + '--is-cued'
			}
		}
	}

	constructor(element) {
		this.options = '';
		this.element = element;
		this.iframe = element.querySelector('.' + VimeoPlayer.classes.iframe);
		this.overlay = element.querySelector('.' + VimeoPlayer.classes.overlay);
		this.poster = element.querySelector('.' + VimeoPlayer.classes.poster);
		this.inner = element.querySelector('.' + VimeoPlayer.classes.inner);
		this.state = 'unstarted';
		this.isInitialised = false;
		this.player = {};
		this.options = {
			id: this.element.dataset.id,
            byline: false
		};

        /*
        var vimeoServiceIsAllowed = uc.whitelisted.value.has('HyEX5Nidi-m');
		if (vimeoServiceIsAllowed && (!this.poster || this.poster.getAttribute('src'))) {
			fetch('https://vimeo.com/api/v2/video/' + element.dataset.id + '.json')
				.then(response => response.json())
				.then(data => {
                    const src = data[0] && (data[0].thumbnail_large || data[0].thumbnail_medium || data[0].thumbnail_small);
					if (src) {
						this.poster.setAttribute('src', src);
					}
				});
		}
         */

        if(this.element.classList.contains('vimeo-player--is-autoplay-loop')) {
            ScrollObserver.onLazyLoad(this.element, entry => {
                this.initializePlayer();
                this.player.setLoop(true);
                this.player.setVolume(0);
                this.player.play().then(() => this.setState('playing'));
            });
        }

        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            return;
        }
		this.overlay.addEventListener('click', () => this.startPlayer());
	}

    startPlayer() {
        this.initializePlayer();
        this.player.play().then(() => this.setState('playing'));
    }

    initializePlayer() {
        if (this.isInitialised) {
            return;
        }

        this.player = new Player(this.inner, this.options);

        this.player.ready().then(() => {
            this.setState('initialised');
            let iframe = this.inner.querySelector('iframe');
            iframe.classList.add('vimeo-player__iframe');
        });

        this.player.on('play', () => this.setState('playing'));
        this.player.on('pause', () => this.setState('paused'));
        this.player.on('ended', () => this.setState('ended'));
    }

	setState(state) {
		let stateClass = VimeoPlayer.classes.state[state];
		if (this.element.classList.contains(stateClass)) return;

		for (let key in VimeoPlayer.classes.state) {
			if (key !== 'initialised') {
				this.element.classList.remove(VimeoPlayer.classes.state[key]);
			}
		}
		this.state = state;
		this.element.classList.add(stateClass);
	}
}

VimeoPlayer.init();
